import React from 'react';
import '../styles/ingredients.css';
import { FaLeaf, FaFlask, FaCrown, FaBolt } from 'react-icons/fa';

const ingredients = [
  { name: "Aurum", desc: "Traditionally used gold leaf known for its rich heritage in wellness formulations.", icon: <FaCrown /> },
  { name: "Crocus sativus (Zafran)", desc: "Premium saffron valued in traditional wellness practices for its aromatic and nourishing qualities.", icon: <FaLeaf /> },
  { name: "Ashwagandha", desc: "A well-known Ayurvedic herb traditionally used to support balance and overall wellbeing.", icon: <FaBolt /> },
  { name: "Salab Misri", desc: "Rare orchid root appreciated in traditional blends for its nourishing properties.", icon: <FaFlask /> },
  { name: "Argentum", desc: "Silver leaf traditionally included in heritage formulations for its refined character.", icon: <FaCrown /> },
  { name: "Musli Safed", desc: "Popular Ayurvedic herb often used in wellness blends supporting vitality and balance.", icon: <FaLeaf /> },
  { name: "Gokshru", desc: "A classical herb used in Ayurvedic traditions as part of holistic wellness routines.", icon: <FaBolt /> },
  { name: "Ambra grasea", desc: "Rare aromatic resin valued in traditional formulations for its distinctive essence.", icon: <FaCrown /> },
  { name: "Kaunch Beej", desc: "Traditional seed known for its use in herbal preparations supporting general wellness.", icon: <FaFlask /> },
  { name: "Maghz-e-Chilghoza", desc: "Nutritious pine nut kernels providing natural richness and nourishment.", icon: <FaLeaf /> }
];

const Ingredients = () => {
  return (
    <section className="ing-section">
      <div className="ing-container">
     <div className="ing-header">
  <span className="ing-badge">Premium Composition</span>
  <h2 className="ing-title">Inside The <span className="text-green">BioSurge</span> Jar</h2>
  <p className="ing-subtitle">
    A thoughtfully crafted blend of traditional herbs, nuts, and honey inspired by Ayurvedic wellness practices.
  </p>
</div>

        <div className="ing-grid">
          {ingredients.map((item, index) => (
            <div className="ing-card" key={index}>
              <div className="ing-icon-box">{item.icon}</div>
              <div className="ing-content">
                <h3>{item.name}</h3>
                <p>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="ing-footer-note">
         <p>Blended with additional traditional herbs and a nourishing honey base.</p>
        </div>
      </div>
    </section>
  );
};

export default Ingredients;